import { AvatarGroup } from '@synoptic/ui-kit/avatar-group/avatar-group.tsx';
import { FC } from 'react';
import { MainStatisticProfileFragmentFragment } from '@/__generated__/graphql.ts';
import { Award } from '@/components/award/award.tsx';
import * as medalsStyles from './medals.css.ts';

interface MedalsProps {
  medals: MainStatisticProfileFragmentFragment['medals'];
}

const medalsLimit = 5;

export const Medals: FC<MedalsProps> = ({ medals }) => {
  if (medals.length === 0) {
    return null;
  }

  const medalsOverLimit = medals.length - medalsLimit;

  return (
    <div className={medalsStyles.medalsCard}>
      <div className={medalsStyles.medalsHeader}>
        <span className={medalsStyles.headerTitle}>Medals</span>
        <AvatarGroup>
          {medals.map(({ medal }) => (
            <Award key={medal.id} medalId={medal.id} />
          ))}

          {medalsOverLimit > 0 ? (
            <div className={medalsStyles.medalsOverLimitBadge}>
              +{medalsOverLimit}
            </div>
          ) : null}
        </AvatarGroup>
      </div>
    </div>
  );
};
